import { BonfireRoutes } from '@/configs/routes/bonfire';
import { DataRoutes } from '@/configs/routes/data';
import { DecisionsRoutes } from '@/configs/routes/decisions';
import { ExploreRoutes } from '@/configs/routes/explore';
import { FoundationForecastingRoutes } from '@/configs/routes/forecasts';
import { OverviewRoutes } from '@/configs/routes/overview';
import { CanvasRoutes } from '@/configs/routes/types';
import type { RouteConfig } from '@/configs/routes/types';

export { CanvasRoutes } from '@/configs/routes/types';
export type { RouteConfig } from '@/configs/routes/types';

export const RouterConfig = {
  [CanvasRoutes.Login]: {
    name: 'Login',
    path: '/login',
    showInNavigation: false,
    showInBreadcrumbs: true,
  },
  ...OverviewRoutes,
  ...DataRoutes,
  ...FoundationForecastingRoutes,
  ...DecisionsRoutes,
  ...ExploreRoutes,
  ...BonfireRoutes,
} as const satisfies Record<CanvasRoutes, RouteConfig>;

export const Routes = Object.values(RouterConfig) as RouteConfig[];
export const HomeRoute = RouterConfig[CanvasRoutes.FoundationForecasting].path;
